<template>
    <div id="RouteView">
        <div class="search open-search">
            <md-icon class="search-glass-icon">search</md-icon>
            <div class="search-field">
                <div class="md-input-focused md-input-container">
                    <input v-model="filterString" type="text" class="md-input"></input>
                </div>
            </div>
        </div>
        <div>
            <div class="mycheck" v-bind:class="[{'scroll-list' : checkifNumberOfTopicsInRouteMoreThan4()}, {'scroll-list-smaller' : !checkifNumberOfTopicsInRouteMoreThan4()}]" id="scrollSize">
                <md-list class="img-list check-avatar selectable">
                    <draggable v-model="topics" id="topicsTabList" @update="onUpdate(topics)">
                        <md-list-item style="width:100%;" @click="" v-for="(topic, index) in topics" :key="topic.id" v-if="filterCheck(topic.name)" v-bind:class="[{'topDotted': notTop(index)}, {'bottomDotted': notBottom(index)}, {'back-grey': topic.mapHover}]" v-on:mouseover="toggleHoverOn(index)" v-on:mouseleave="toggleHoverLeave(index)">
                             <span v-if="topic.checkCompleteImages == 1">
                                <img class="completeImages" src="static/img/complete.png">
                            </span>
                            <span v-else>
                                <img class="inCompleteImages" style="width :13px" src="static/img/inComplete.png">
                            </span>
                            <div class="routeNameInfo" role="button">
                                <div class="avatar s-36 material-icons material-icons-My" @click="navigateToTopic(topic, index)">
                                    <img :src="getImageSrc(topic.avatar)"/>
                                </div>
                                <div class="md-list-item-text">
                                    <md-button>
                                        <div @click="navigateToTopic(topic, index)">
                                            <h3>{{ topic.name }}</h3>
                                            <p>{{ topic.address }}</p>
                                        </div>
                                        <md-tooltip md-direction="right" :md-active.sync="tooltipActive[index]" class="hoverAtchedStory" style="height:auto; margin-left:6%">
                                            <span v-if="triggersListTrue">
                                                <span v-for="(trigger) in triggersList" :key="trigger.toiId">
                                                    <p v-if="topic.id == trigger.toiId">
                                                        <span v-if="trigger.storyName">
                                                            <span>{{ trigger.storyName }}</span>
                                                            <span v-if="trigger.extra_story_id">
                                                                <br>
                                                                <span>{{ trigger.storyNameCopy }}</span>
                                                            </span>
                                                        </span>
                                                    </p>
                                                </span>
                                            </span>
                                        </md-tooltip>
                                    </md-button>
                                </div>
                                <md-button title="Remove Topic from Route" class="md-icon-button" @click="confirmDelete(index)">
                                    <md-icon>delete</md-icon>
                                </md-button>
                            </div>
                        </md-list-item>
                    </draggable>
                </md-list>
            </div>
            <div v-if="pencilIconSelected">
                <footer v-if="(pencilIconSelected && pathHasPoints) || routeChanged" class="aside-btn">
                    <div class="btn-wrap" v-show="pencilIconSelected && pathHasPoints" v-bind:class="{ 'add-btn': (routeChanged && pencilIconSelected && pathHasPoints) }">
                        <md-button class="md-raised md-primary" @click="confirmDeleteClear(1)">Clear Path</md-button>
                    </div>
                    <div class="btn-wrap" v-bind:class="{ 'add-btn': (routeChanged && pencilIconSelected && pathHasPoints) }">
                        <md-button class="md-raised md-primary" v-show="pencilIconSelected && pathHasPoints" @click="saveRoute">Save Route</md-button>
                    </div>
                </footer>
            </div>
            <div v-if="pencilIconSelectedAlt">
                <footer v-if="(pencilIconSelectedAlt && pathHasPointsAlt) || routeChangedAlt" class="aside-btn">
                    <div class="btn-wrap" v-show="pencilIconSelectedAlt && pathHasPointsAlt" v-bind:class="{ 'add-btn': (routeChangedAlt && pencilIconSelectedAlt && pathHasPointsAlt) }">
                        <md-button class="md-raised md-primary" @click="confirmDeleteClear(0)">Clear Alternate Path</md-button>
                    </div>
                    <div class="btn-wrap" v-bind:class="{ 'add-btn': (routeChangedAlt && pencilIconSelectedAlt && pathHasPointsAlt) }">
                        <md-button class="md-raised md-primary" v-show="pencilIconSelectedAlt && pathHasPointsAlt" @click="saveRouteAlt">Save Alternate Route</md-button>
                    </div>
                </footer>
            </div>
        </div>
        <md-dialog :md-click-outside-to-close="false" :md-active.sync="showDeleteDialog">
            <md-dialog-title>
                Confirm Delete
            </md-dialog-title>
            <md-dialog-content>
                Deleting this Topic will delete these TriggerZones associated with it:
                <div>
                    <br>
                    <span v-for="(trigger) in triggersList" :key="trigger.toiId">
                        <p style="margin-bottom:-15px" v-if="showTriggerListId == trigger.toiId">
                            <b><span>-{{ trigger.name }}</span></b>
                        </p>
                    </span>
                </div>
            </md-dialog-content>
            <md-dialog-actions class="full-btn">
                <md-button class="ManualBtn ManualBtndelete" @click="clickDeleteTopic(topicDeleteid)">DELETE</md-button>
                <md-button class="ManualBtn ManualBtncancel" @click="showDeleteDialog = false">CANCEL</md-button>
            </md-dialog-actions>
        </md-dialog>
        <md-dialog :md-click-outside-to-close="false" :md-active.sync="showDeleteDialogPath">
            <md-dialog-title>
                Confirm Delete
            </md-dialog-title>
            <md-dialog-content>
                Are you sure you want to delete this path?
            </md-dialog-content>
            <md-dialog-actions class="full-btn">
                <md-button class="ManualBtn ManualBtndelete" @click="clickDeleteTopic(topicDeleteid)">DELETE</md-button>
                <md-button class="ManualBtn ManualBtncancel" @click="showDeleteDialog = false">CANCEL</md-button>
            </md-dialog-actions>
        </md-dialog>
        <md-dialog :md-click-outside-to-close="false" :md-active.sync="showDeleteDialogClear">
            <md-dialog-title>
                Confirm Delete
            </md-dialog-title>
            <md-dialog-content>
                Are you sure you want to erase the drawn path?
            </md-dialog-content>
            <div v-if="deletePathConfirmation === 1">
                <md-dialog-actions class="full-btn">
                    <md-button class="ManualBtn ManualBtndelete" @click="deletePath()">DELETE</md-button>
                    <md-button class="ManualBtn ManualBtncancel" @click="showDeleteDialogClear = false">CANCEL</md-button>
                </md-dialog-actions>
            </div>
            <div v-if="deletePathConfirmation === 0">
                <md-dialog-actions class="full-btn">
                    <md-button class="ManualBtn ManualBtndelete" @click="deletePathAlt()">Delete</md-button>
                    <md-button class="ManualBtn ManualBtncancel" @click="showDeleteDialogClear = false">CANCEL</md-button>
                </md-dialog-actions>
            </div>
        </md-dialog>
    </div>
</template>
<script>
import draggable from 'vuedraggable';
import {mapGetters, mapActions} from 'vuex';
import VueCookies from 'vue-cookies';
import {deleteRouteTopic} from '../../services/RouteService.js';
import {updatePriorityForTopicROute} from '../../services/LibraryService.js';

export default {
  data () {
    return {
      showDeleteDialogPath: false,
      topicDeleteid: '',
      showDeleteDialog: false,
      filterString: '',
      tooltipActive: [],
      triggerzone: [],
      scrollHeightUsingRefsVuejs: '',
      scrollWidth: '',
      showDeleteDialogClear: false,
      deletePathConfirmation: '',
      triggersListTrue: false,
      showTriggerListId: ''
    };
  },
  computed: {
    ...mapGetters('routes', ['currentRoute', 'currentRouteAlt', 'routeTopics', 'routeChanged', 'routeChangedAlt', 'pathHasPoints', 'pathHasPointsAlt', 'removedTopics']),
    ...mapGetters('map', ['pencilIconSelected', 'pencilIconSelectedAlt']),
    ...mapGetters('topics', ['topicsList']),
    ...mapGetters('triggers', {triggersList: 'triggersList'}),
    filterStringIsEmpty () {
      return this.filterString.replace(/^\s+|\s+$/g, '').length === 0;
    },
    topics: {
      get: function () {
        return this.routeTopics;
      },
      set: function (value) {
        this.updateTopicOrder({topics: value});
      }
    }
  },
  beforeDestroy () {
    this.$bus.$off('scrollList');
  },
  methods: {
    ...mapActions('routes', ['loadRouteTopics', 'updateTopicOrder', 'updateInitialTopicList', 'saveRouteChanges', 'clearRouteTopics', 'killPath', 'killPathAlt', 'setUpdateCheck', 'setUpdateCheckAlt', 'removeRouteTopic', 'removeRouteTopicAlt', 'removeRouteTopicsFromState', 'resetRemovedTopics', 'resetRemovedTopicsAlt']),
    ...mapActions('map', ['setCenter']),
    ...mapActions('topics', ['loadEditorTopic', 'setTopicsList', 'removeMapTopicsFromState']),
    ...mapActions('triggers', ['loadRouteTriggers', 'clearStateTriggersList', 'removeMapTriggersFromState']),
    getImageSrc (image) {
      if (image.substring(0, 5) !== 'https') {
        return 'static/img/' + image;
      } else {
        return image;
      }
    },
    onUpdate (cate) {
      updatePriorityForTopicROute(cate);
    },
    confirmDelete (id) {
      this.showDeleteDialog = true;
      this.showTriggerListId = this.routeTopics[id].id;
      this.topicDeleteid = id;
    },
    confirmDeleteClear (type) {
      this.deletePathConfirmation = type;
      this.showDeleteDialogClear = true;
    },
    notTop (index) {
      return index > 0 && this.topics.length > 1 && this.filterStringIsEmpty;
    },
    notBottom (index) {
      return index < this.topics.length - 1 && this.topics.length > 1 && this.filterStringIsEmpty;
    },
    filterCheck (text) {
      var passesFilter = true;
      if (text && text.replace(/^\s+|\s+$/g, '').length > 0 && !this.filterStringIsEmpty) {
        passesFilter = (text.toLowerCase()).includes(this.filterString.toLowerCase());
      }
      return passesFilter;
    },
    checkifNumberOfTopicsInRouteMoreThan4 () {
      return this.routeTopics.length > 4;
    },
    deletePath () {
      this.killPath();
      this.setUpdateCheck(true);
      this.showDeleteDialogClear = false;
      this.deletePathConfirmation = '';
      this.pencilIconSelected = false;
      if (this.removedTopicsAlt !== []) {
        this.removeRouteTopicAlt([this.currentRouteAlt.id, this.removedTopics]);
        this.resetRemovedTopicsAlt();
      }
      var topicOrder = [];
      for (var topic of this.routeTopics) {
        topicOrder.push({route: this.currentRouteAlt.id, topic: topic.id, orderInRoute: topic.orderInRoute});
      }
      this.saveRouteChanges({topicOrder: topicOrder, routeTopics: this.routeTopics});
    },
    deletePathAlt () {
      this.killPathAlt();
      this.setUpdateCheckAlt(true);
      this.showDeleteDialogClear = false;
      this.deletePathConfirmation = '';
      if (this.removedTopicsAlt !== []) {
        this.removeRouteTopicAlt([this.currentRouteAlt.id, this.removedTopics]);
        this.resetRemovedTopicsAlt();
      }
      var topicOrder = [];
      for (var topic of this.routeTopics) {
        topicOrder.push({route: this.currentRouteAlt.id, topic: topic.id, orderInRoute: topic.orderInRoute});
      }
      this.saveRouteChanges({topicOrder: topicOrder, routeTopics: this.routeTopics});
    },
    saveRoute () {
      if (this.removedTopics !== []) {
        this.removeRouteTopic([this.currentRoute.id, this.removedTopics]);
        this.resetRemovedTopics();
      }
      var topicOrder = [];
      for (var topic of this.routeTopics) {
        topicOrder.push({route: this.currentRoute.id, topic: topic.id, orderInRoute: topic.orderInRoute});
      }
      this.saveRouteChanges({topicOrder: topicOrder, routeTopics: this.routeTopics});
    },
    saveRouteAlt () {
      if (this.removedTopicsAlt !== []) {
        this.removeRouteTopicAlt([this.currentRouteAlt.id, this.removedTopics]);
        this.resetRemovedTopicsAlt();
      }
      var topicOrder = [];
      for (var topic of this.routeTopics) {
        topicOrder.push({route: this.currentRouteAlt.id, topic: topic.id, orderInRoute: topic.orderInRoute});
      }
      this.saveRouteChanges({topicOrder: topicOrder, routeTopics: this.routeTopics});
    },
    navigateToTopic (topic, newIndex) {
      VueCookies.set('scrollTopHeight', newIndex);
      this.scrollWidth = VueCookies.get('scrollTopHeight');
      if (this.scrollWidth > 0) {
        this.$bus.$emit('hoveredTopic', {topicIndex: newIndex, toggle: false});
      }
      this.loadEditorTopic(topic);
      this.setCenter(topic);
      this.clearStateTriggersList();
      this.$router.push('/tour/topic');
    },
    // since the list order can be changed we need to pass where in the list the topic highlighted WAS, so that the function interacting with the emit can process it properly
    toggleHoverOn (index) {
      let newIndex = index;
      for (let i = 0; i < this.topicsList.length; i++) {
        if (this.topicsList[i].id === this.routeTopics[index].id) {
          newIndex = i;
        }
      }
      this.$bus.$emit('hoveredTopic', {topicIndex: newIndex, toggle: true});
      this.routeTopics[index].hover = true;
    },
    toggleHoverLeave (index) {
      let newIndex = index;
      for (let i = 0; i < this.topicsList.length; i++) {
        if (this.topicsList[i].id === this.routeTopics[index].id) {
          newIndex = i;
        }
      }
      this.$bus.$emit('hoveredTopic', {topicIndex: newIndex, toggle: false});
      this.routeTopics[index].hover = false;
    },
    clickDeleteTopic (index) {
      deleteRouteTopic(this.currentRoute.id, this.routeTopics[index].id);
      this.removedTopics.push(this.routeTopics[index].id);
      this.removeMapTriggersFromState(this.routeTopics[index].id);
      this.removeRouteTopicsFromState(index);
      this.removeMapTopicsFromState(index);
      this.topicDeleteid = '';
      this.showDeleteDialog = false;
    }
  },
  components: {
    draggable: draggable
  },
  mounted () {
    this.clearRouteTopics();
    this.loadRouteTopics().then(() => {
      this.setTopicsList(this.routeTopics);
    });
    this.clearStateTriggersList();
    this.loadRouteTriggers(this.currentRoute.id).then(() => {
      if (this.triggersList.length > 0) {
        this.triggersListTrue = true;
      }
    });
    this.resetRemovedTopics();
    this.resetRemovedTopicsAlt();
    this.$bus.$on('scrollList', ($params) => {
      if ($params.toggle) {
        this.tooltipActive[$params.topicIndex] = true;
        let container = document.getElementById('scrollSize');
        let element = document.getElementById('topicsTabList').childNodes[$params.topicIndex];
        let cTop = container.scrollTop;
        let cBottom = cTop + container.clientHeight;

        // Determine element top and bottom
        let eTop = element.offsetTop;
        let eBottom = eTop + element.clientHeight;

        // Check if out of view
        if (eTop < cTop || eBottom > cBottom) {
          container.scrollTop -= (cTop - eTop);
        } else if (eBottom > cBottom) {
          container.scrollTop += (eBottom - cBottom);
        }
      } else {
        this.tooltipActive[$params.topicIndex] = false;
      }
    });
    this.scrollWidth = VueCookies.get('scrollTopHeight');
    if (this.scrollWidth > 0) {
      let pp = this;
      this.intervalid1 = setTimeout(function () {
        let container = document.getElementById('scrollSize');
        let element = document.getElementById('topicsTabList').childNodes[pp.scrollWidth];
        let cTop = container.scrollTop;
        let cBottom = cTop + container.clientHeight;
        // Determine element top and bottom
        let eTop = element.offsetTop;
        let eBottom = eTop + element.clientHeight;
        // Check if out of view
        if (eTop < cTop || eBottom > cBottom) {
          container.scrollTop -= (cTop - eTop);
        } else if (eBottom > cBottom) {
          container.scrollTop += (eBottom - cBottom);
        }
        VueCookies.set('scrollTopHeight', 0);
      }, 1000);
    }
  }
};
</script>
<style lang="scss">
.material-icons-My img {
    margin-top: 0px !important;
}

.topDotted:before, .bottomDotted:after {
    width: 1px;
    height: 50%;
    position: absolute;
    left: 42px;
    border-left: 1px dotted #8c8c8c;
    overflow: hidden;
    display: block;
    content: '';
}

.topDotted:before {
    top: 1px;
}

.bottomDotted:after {
    bottom: 1px;
}

#RouteView .md-list-item-text {
    width: 210px;
    display: inline-flex;
}

#RouteView .scroll-list {
    position: absolute;
    top: 248px;
    bottom: 96px;
    left: 0;
    right: 0;
    overflow: auto;
}

#RouteView .scroll-list-smaller {
    position: absolute;
    top: 248px;
    bottom: 150px;
    left: 0;
    right: 0;
    overflow: auto;
}

.add-btn {
    bottom: 48px;
}

#RouteView .md-icon-button {
    width: 48px;
    display: inline-flex;
}

.back-grey {
    background-color: rgb(224, 224, 224);
}

.routeNameInfo {
    display: flex;
    align-items: center;
    width: 273px;
}

.md-ripple.md-list-item-content > span {
    margin-left: 10px;
}

.hoverAtchedStory {
    height: auto;
}

.map-page .md-list-item .avatar {
    margin: 0 !important;
}

button.md-button.ManualBtn.ManualBtndelete.md-theme-default span.md-button-content {
    font-size: 15px;
}

button.md-button.ManualBtn.ManualBtncancel.md-theme-default span.md-button-content {
    font-size: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/tour/TourRoute.vue